import React, { useState } from "react";
import { Formik, Form } from "formik";
import { Modal } from "seed/helpers";
import l from "components/util/l";
import Roles from "components/presentation/sections/settings/roles/Roles";
import GeneralPermissionField from "components/util/helpers/user/permissions/PermissionField.lib.general";
import ProcessPermissionField from "components/util/helpers/user/permissions/PermissionField.lib.process";
import CollectionPermissionField from "components/util/helpers/user/permissions/PermissionField.lib.collection";

const toValuesById = (items = []) =>
  items.reduce((acc, item) => {
    acc[item.id] = item.permissions || {};
    return acc;
  }, {});

const PermissionsView = ({
  flow,
  views = [],
  general = {},
  details = {},
  collections = [],
  nodes = [],
  isUpdating,
  isRolesModalOpen,
  onSubmit,
  onOpenRolesModal,
  onCloseRolesModal,
}) => {

  const [tab, setTab] = useState("GENERAL");

  const initialValues = {
    general,
    details,
    collections: toValuesById(collections),
    nodes: toValuesById(nodes),
  };

  return (
    <div className="card pt-1 pb-3 px-5 my-4 py-3 w-100">

      <h2 className="mb-3">{l("Permisos%PA107")}</h2>

      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}>
        {({ values, setFieldValue }) =>
          <Form>

            <div id="permission-tabs" className="d-flex mb-4">
              <button
                type="button"
                className={"dropdown-header py-2 " + (tab === "GENERAL" ? "active" : "")}
                style={{ fontSize: "0.85em" }}
                onClick={() => setTab("GENERAL")}
              >
                {l("General%GA097")}
              </button>
              <button
                type="button"
                className={"dropdown-header py-2 " + (tab === "PROCESSES" ? "active" : "")}
                style={{ fontSize: "0.85em" }}
                onClick={() => setTab("PROCESSES")}
              >
                {l("Procesos%GA095")}
              </button>
              <button
                type="button"
                className={"dropdown-header py-2 " + (tab === "DATA" ? "active" : "")}
                style={{ fontSize: "0.85em" }}
                onClick={() => setTab("DATA")}
              >
                {l("Datos%GA096")}
              </button>
            </div>

            {
              tab === "GENERAL" &&
              <GeneralPermissionField
                flowId={flow.id}
                views={views}
                values={values.general}
                details={values.details}
                setFieldValue={(field, value) =>
                  setFieldValue("general", { ...values.general, [field]: value })
                }
                setValues={(next) => setFieldValue("general", next)}
                setDetails={(next) => setFieldValue("details", next)}
              />
            }

            {
              tab === "PROCESSES" &&
              nodes.map((node) =>
                <div key={`node-${node.id}`}>
                  <label
                    className="dropdown-header px-0 pt-2 pb-0 text-dark"
                    style={{ textTransform: "none" }}
                  >
                    {node.name}
                  </label>
                  <div className="mt-n2 pb-2">
                    <ProcessPermissionField
                      flowId={flow.id}
                      values={values.nodes[node.id] || {}}
                      setFieldValue={(field, value) =>
                        setFieldValue("nodes", {
                          ...values.nodes,
                          [node.id]: { ...(values.nodes[node.id] || {}), [field]: value },
                        })
                      }
                      setValues={(next) =>
                        setFieldValue("nodes", { ...values.nodes, [node.id]: next })
                      }
                    />
                  </div>
                </div>
              )
            }

            {
              tab === "DATA" &&
              collections.map((collection) =>
                <div key={`collection-${collection.id}`}>
                  <label className="dropdown-header px-0 pb-0 text-dark">
                    {collection.name}
                  </label>
                  <div className="mt-n2 pb-2">
                    <CollectionPermissionField
                      flowId={flow.id}
                      values={values.collections[collection.id] || {}}
                      setFieldValue={(field, value) =>
                        setFieldValue("collections", {
                          ...values.collections,
                          [collection.id]: { ...(values.collections[collection.id] || {}), [field]: value },
                        })
                      }
                      setValues={(next) =>
                        setFieldValue("collections", { ...values.collections, [collection.id]: next })
                      }
                    />
                  </div>
                </div>
              )
            }

            <div className="w-100 text-right">
              <button
                type="button"
                onClick={onOpenRolesModal}
                className="btn btn-link mb-4"
              >
                <i className="fas fa-user-group mr-2"></i>
                {l("Personalizar roles%PA072")}
              </button>
            </div>

            <button
              type="submit"
              className="btn btn-primary font-weight-bold w-100 mt-4"
              disabled={isUpdating}
            >
              {isUpdating
                ? <i className="fas fa-circle-notch fa-spin mr-2"></i>
                : l("Guardar%GA023")
              }
            </button>

          </Form>}
      </Formik>

      {
        isRolesModalOpen &&
        <Modal
          width={750}
          height={600}
          flow={flow}
          component={Roles}
          onClose={onCloseRolesModal}
        />
      }

    </div>
  );
};

export default PermissionsView;
